import { render, staticRenderFns } from "./VarietyRow.vue?vue&type=template&id=2a69a394&scoped=true&"
import script from "./VarietyRow.vue?vue&type=script&lang=js&"
export * from "./VarietyRow.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/product/varieties/VarietyRow/VarietyRowStyle.css?vue&type=style&index=0&id=2a69a394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69a394",
  null
  
)

export default component.exports